export default [
    {
      path: '/users/list',
      name: 'list-users',
      meta: {
        requiresAuth: true,
        title: 'Buscar Usuários'
      },
      component: () =>
        import(/* webpackChunkName: "profile" */ '@/components/users/ListUsers.vue')
    },
    {
      path: '/users/:id?',
      name: 'search-users',
      meta: {
        requiresAuth: true,
        title: 'Usuários'
      },
      component: () =>
        import(/* webpackChunkName: "profile" */ '@/components/users/SearchUser.vue')
    }
]
  